<template>
  <el-card shadow="always">
    <el-form ref="form" :model="ruleForm" label-width="120px">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="E-commerce" prop="type">
            <el-radio-group v-model="ruleForm.type">
              <el-radio-button key="1" label="1">
                <VtexSvg width="55px" height="31px" />
              </el-radio-button>
              <el-radio-button key="2" label="2">
                <LinxSvg width="55px" height="31px" />
              </el-radio-button>
              <el-radio-button key="3" label="3">
                <IrrobaSvg width="55px" height="31px" />
              </el-radio-button>
              <el-radio-button key="4" label="4">
                <LojaIntegradaSvg width="55px" height="31px" />
              </el-radio-button>
              <el-radio-button key="5" label="5">
                <TraySvg width="55px" height="31px" />
              </el-radio-button>
              <el-radio-button key="6" label="6">
                <IntelliSvg width="55px" height="31px" />
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="14" :sm="12" :md="10" :lg="8" :xl="4">
          <el-form-item :label="$t('cep-origem')" prop="zipcode">
            <el-input maxlength="9" v-model="ruleForm.cep" v-mask="'#####-###'" @blur="zipcode()"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="14" :sm="6" :md="3" :lg="3" :xl="2" v-for="record of tableData" :key="record.id">
          <el-checkbox v-model="record.selected" v-if="record.image">
            <img :src="record.image" width="100" height="80px" class="image" />
          </el-checkbox>
        </el-col>
      </el-row>
      <el-form-item style="text-align: center">
        <el-button type="primary" @click="doexport()">Exportar</el-button>
      </el-form-item>
    </el-form>
</el-card>
</template>

<script>
import { ServicesGroupService } from "@/services/customers/services.group.services";
import { ExportService } from "@/services/customers/export.services";
import ZipMixins from "../../../mixins/zipcode";
import IrrobaSvg from "./logo/IrrobaSvg.vue";
import VtexSvg from "./logo/VtexSvg.vue";
import LinxSvg from "./logo/LinxSvg.vue";
import LojaIntegradaSvg from "./logo/LojaIntegradaSvg.vue";
import TraySvg from './logo/TraySvg.vue';
import IntelliSvg from './logo/IntelliSvg.vue';

export default {
    name: "ExportPricetable",
    props: ["customer", "source"],
    mixins: [ZipMixins],
    watch: {
        customer() {
            this.refresh();
        },
    },
    mounted() {
        this.refresh();
        this.ruleForm.cep = this.source;
    },
    methods: {
        changed(zipcode) {
            this.ruleForm.cep = zipcode;
        },
        refresh() {
            const vm = this;
            if (vm.customer) {
                const loading = vm.$loading(vm.$options.loading);
                ServicesGroupService.list(vm.customer)
                    .then((response) => {
                    vm.tableData = response.records;
                })
                    .catch((error) => {
                    this.$message({ type: "error", message: error });
                })
                    .finally(() => loading.close());
            }
        },
        doexport() {
            const vm = this;
            const loading = vm.$loading(vm.$options.loading);
            ExportService.boundary({
                type: vm.ruleForm.type,
                zipcode: vm.ruleForm.cep,
                customer: vm.customer,
                serviceGroup: vm.tableData.filter(x => x.selected).map(x => x.id)
            })
                .then((response) => {
                this.$message({
                    type: "warning",
                    message: 'Sua exportação da tabela de preço está sendo gerada, assim que terminar você receberá uma notificação no canto superior direito!',
                    duration: 5000,
                });
                vm.$bus.$emit("notifications", response.id);
            })
                .catch((error) => {
                this.$message({
                    type: "error",
                    dangerouslyUseHTMLString: true,
                    message: error,
                });
            })
                .finally(() => loading.close());
        },
    },
    data() {
        return {
            tableData: [],
            ruleForm: {
                type: '1',
                cep: '',
            },
        };
    },
    components: { IrrobaSvg, VtexSvg, LinxSvg, LojaIntegradaSvg, TraySvg, IntelliSvg }
};
</script>
<style scoped>
.image-service {
  width: 100px;
  height: 60px;
  display: block;
}
</style>